import React, { useMemo } from 'react';
import BespokeMarket from '../../../BespokeMarkets/BespokeMarket';

const BespokeMarketPage = ({ activeRace, bespokeMarkets = [] }) => {
  const raceMarkets = useMemo(
    () => bespokeMarkets?.filter((m) => m.eventId === activeRace?.raceId) || [],
    [bespokeMarkets, activeRace?.raceId],
  );

  if (!activeRace) {
    return null;
  }

  return (
    <div className='bespoke-market__list'>
      {raceMarkets?.map((market) => (
        <BespokeMarket key={market.id} bespokeMarket={market} />
      ))}
    </div>
  );
};

export default BespokeMarketPage;
